const $         = require('jquery');
const { icon }  = require('@fortawesome/fontawesome-svg-core');
const tippy     = require('tippy.js/dist/tippy-bundle.umd.js');
const eventer   = require('../util/eventer');

const faIconOpts14 = { classes: ['fa-icon icon-h-14'] };
const faIconOpts16 = { classes: ['fa-icon icon-h-16'] };
const fa = {
  times: require('@fortawesome/pro-light-svg-icons/faTimes').definition
};

let api = eventer({});
let elem = $();
let backdrop = $();
let activeId = '';
let activeView = null;
let isOpen = false;

const BD_TPL = '<div class="backdrop span"></div>';
const TPL = `
  <div class="sidepanel wrfont">
    <div class="header"></div>
    <div class="content"></div>
  </div>
`;

function init({ container }) {
  if (elem.length) return;
  backdrop = $(BD_TPL).click(close);
  elem = $(TPL).appendTo(container);
  return api;
}

function createHeader(opts) {
  let header = $(`
    <div>
      <div class="btns-left"></div>
      <div class="title truncate" data-tippy-content="${opts.title}">${opts.title}</div>
      <div class="btns-right">
        <button class="toolbar-btn close" data-tippy-content="Close">
          ${icon(fa.times, faIconOpts14).html}
        </button>
      </div>
    </div>
  `).on('click', '.close', close);

  (opts.buttons || []).forEach(action => {
    $(`
      <button class="toolbar-btn" data-tippy-content="${action.title || ''}">
        ${icon(action.icon, faIconOpts16).html}
      </button>
    `).on('click', action.handler).appendTo(header.find('.btns-left'));
  });

  header.find('button[data-tippy-content]').each((idx, el) => {
    tippy(el, { placement: 'bottom' });
  });

  return header;
}

function open(opts) {
  if (isOpen) {
    if (activeId !== opts.id) update(opts);
    return;
  }
  isOpen = true;
  elem.one('transitionend', e => {
    setTimeout(() => {
      if (isOpen && opts.shrinkToWidth) {
        // evtbus.trigger('shrink-to-width');
      }
    }, 100);
  });
  update(opts);
  backdrop.appendTo(elem.parent());
  setTimeout(() => elem.parent().addClass('sidepanel-open'));
}

function close() {
  if (!isOpen) return;
  isOpen = false;
  elem.one('transitionend', () => {
    elem.removeClass(activeId);
    activeId = '';
    if (activeView) {
      activeView.trigger('deactivate');
      activeView = null;
    }
  });
  elem.parent().removeClass('sidepanel-open');
  elem.children('.content').scrollTop(0);
  backdrop.detach();
  api.trigger('closed');
}

function update(opts) {
  activeId = opts.id;
  activeView = opts.content;
  elem.addClass(activeId);
  elem.children('.header').empty().append(createHeader(opts));
  elem.children('.content').children().detach();
  elem.children('.content').append(activeView);
  activeView.trigger('attached');
  activeView.trigger('activate');
  api.trigger('opened', [activeId]);
}

function header(opts) {
  elem.children('.header').empty().append(createHeader(opts));
}

function toggle(opts) {
  if (isOpen) {
    activeId === opts.id ? close() : update(opts);
  } else {
    open(opts);
  }
}

api.init = init;
api.open = open;
api.close = close;
api.update = update;
api.header = header;
api.toggle = toggle;

Object.defineProperty(api, 'isOpen', {
  get() { return isOpen; }
});
Object.defineProperty(api, 'activeId', {
  get() { return activeId; }
});

module.exports = api;
